import { message } from "antd";
import * as api from "../api";
import {
  CREATESTORE,
  FETCHSTORE,
  FETCH_ALL_STORES,
  UPDATESTORE,
} from "../constants/actionTypes";

export const createStore =
  (formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createStore(formData);
      dispatch({ type: CREATESTORE, data });
      if (data) {
        setLoadingButton(false);
        message.success("Your store added successfully! Please login now");
        history("/");
      }
    } catch (error) {
      if (error) {
        console.log(error);
        setLoadingButton(false);
        // message.error(error?.response?.data);
      }
    }
  };

export const getStore = (storeId) => async (dispatch) => {
  try {
    const { data } = await api.getStore(storeId);
    dispatch({ type: FETCHSTORE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateStore =
  (id, formData, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateStore(id, formData);
      dispatch({ type: UPDATESTORE, payload: data });
      if (data?._id) {
        setLoadingButton(false);
        message.success("Store updated successfully");
        window.location.replace("/store");
      }
    } catch (error) {
      if (error) {
        setLoadingButton(false);
        console.log(error);
        message.error(error?.response?.data);
      }
    }
  };

export const getStores = () => async (dispatch) => {
  try {
    const { data } = await api.getStores();
    dispatch({ type: FETCH_ALL_STORES, payload: data });
  } catch (error) {
    console.log(error);
  }
};
